import { Badge, Chip, ChipProps, Link, ChipPropsColorOverrides, Stack } from '@mui/material';
import CutterTooltip from '../common/CutterTooltip';
import NavigableHtml from '../common/NavigableHtml';
import { OverridableStringUnion } from "@mui/types";
import React from 'react';

import { CutterState, navigateTabsWithQueries } from "../types/cutterState";
import { getDurationStringFromDays, getFormatedStringFromDate } from "../utils/dateUtils";

import Warning from '@mui/icons-material/Warning';
import { NavigateFunction } from 'react-router-dom';
import { CopyToClipboard } from '../common/CopyToClipBoard';
import { ContentCopy } from '@mui/icons-material';

type CutterLastConnDurationProps = {
    cutter: CutterState;
    navigate: NavigateFunction;
} & ChipProps

export const CutterLastConnDuration: React.FC<CutterLastConnDurationProps> = (props) => {
    const { cutter, navigate, ...others } = props;
    // lastNews = lastNews ?? -1000;

    interface alertProps {
        message: string;
        severity: OverridableStringUnion<'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', ChipPropsColorOverrides>
    };

    let alertValue: alertProps = {
        message: '',
        severity: 'error'
    };

    let chipProps = { ...others, sx: { ...others.sx, fontWeight: 600 } };

    if (cutter.latestNewsDays > 36500) { // > 100 years → sentinel date (no data)
        alertValue = {
            message: '', severity: "default"
        };
        chipProps = { ...others, sx: { ...others.sx, fontWeight: 600, color: '#ffffff', backgroundColor: '#010101' } }
    }

    if (cutter.latestNewsDays <= 30) alertValue = { message: '', severity: "warning" };
    if (cutter.latestNewsDays <= 14) alertValue = { message: '', severity: "info" };
    if (cutter.latestNewsDays <= 2) alertValue = { message: '', severity: "success" };
    if (!cutter.hasContract) alertValue.severity = 'default';


    // Check if there are any diagnostic failures
    if (!cutter.diagnostics || cutter.diagnostics.isValid || !cutter.diagnostics.failures || cutter.diagnostics.failures.length === 0) {
        return (<Chip color={alertValue.severity} {...chipProps}
            label={getDurationStringFromDays(cutter.latestNewsDays) + ' ' + alertValue.message} size="small" />);
    }

    const { sx } = others;
    const firstFailure = cutter.diagnostics.failures[0];
    const isIntegrationIssue = firstFailure.etlStep < 4;

    return (
        <Badge component='div' sx={sx} badgeContent={
            <CutterTooltip severity="warning" sx={{ fontSize: '1.5em' }} title={
                <>
                    <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                        {isIntegrationIssue ? (
                            <u><b>Integration issue on {getFormatedStringFromDate(cutter.diagnostics.lastKnownChange)}</b></u>)
                            :
                            (<u><b>Issue on {getFormatedStringFromDate(cutter.diagnostics.lastKnownChange)}</b></u>)}
                        <CopyToClipboard
                            TextToCopy={cutter.diagnostics.failures.map(f => f.errorMessage).join('\n')} title='Copy to clipboard'
                            AckMessage='Log copied to clipboard'>
                            <ContentCopy sx={{ fill: 'white', color: 'inherit', padding: 0, fontSize: '1rem' }} titleAccess="Copy log for translation" />
                        </CopyToClipboard>
                    </Stack>
                    <ul style={{ margin: '8px 0', paddingLeft: '20px', listStyleType: 'disc' }}>
                        {cutter.diagnostics.failures.map((failure, index) => (
                            <li key={index} style={{ marginBottom: '4px' }}>
                                <NavigableHtml html={failure.errorMessage} />
                            </li>
                        ))}
                    </ul>

                </>
            } placement="top"><Warning color="warning" sx={{ size: 'large' }} /></CutterTooltip>}>
            <Chip color={alertValue.severity} {...chipProps} sx={{ ...chipProps.sx, width: '100%', fontSize: '0.6rem' }}
                label={getDurationStringFromDays(cutter.latestNewsDays) + ' ' + alertValue.message} size="small" />
        </Badge>
    )

};

